import * as React from "react";

interface BlockProps {
    className?: string;
    style?: React.CSSProperties;
    width?: number | string;
    children: React.ReactNode | readonly React.ReactNode[];
    "data-tid"?: string;
}

export function Block(props: BlockProps): JSX.Element {
    return (
        <div style={{ width: props.width, ...props.style }} className={props.className} data-tid={props["data-tid"]}>
            {props.children}
        </div>
    );
}
